import { FC, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { UI_CONSTANTS } from "../../../Constants/constants";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { IColumn } from "../../../Types/gridDataProps";

const ProductAttributes: FC<DataTableType> = (props: DataTableType) => {
  const user = useSelector((state: any) => state.auth.user);

  const columnDefinition: IColumn[] = [
    {
      name: "Item Number",
      accessor: "SainId",
    },
    {
      name: "Display Item Number",
      accessor: (rowData: any) => {
        return {
          value: rowData?.SkuNumber ? rowData?.SkuNumber : rowData?.CatNumber,
        };
      },
    },
    {
      name: "Description",
      accessor: "Description",
    },
    {
      name: "UOM",
      accessor: (rowData: any) => {
        return {
          value:
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_SKU ||
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_PACK
              ? `CS${rowData?.PackSize}`
              : rowData?.Alias === UI_CONSTANTS.ARGOS
              ? (rowData?.PackSize == 1) ? `EA` : `CS${rowData?.PackSize}`
              : rowData?.PackSize,
        };
      },
    },
    {
      name: "Hazardous",
      accessor: "Hazardous",
      type: "tick",
    },
    {
      name: "Hazardous Code",
      accessor: (rowData: any) => {
        return {
          value: rowData?.Hazardous
            ? rowData?.HazardousCode
              ? rowData.HazardousCode
              : "NONE"
            : "--",
        };
      },
    },
    {
      name: "Nested",
      accessor: "NestedItem",
      type: "tick",
    },
    {
      name: "Nested Increment",
      accessor: "NestedIncrement",
    },
    {
      name: "Ugly",
      accessor: "Uglies",
      type: "tick",
    },
    {
      name: "MU Type",
      accessor: (rowData: any) => {
        return {
          value: rowData?.MUType ? rowData?.MUType : "NONE",
        };
      },
    },
    {
      name: "2 person lift",
      accessor: "TwoPersonLift",
      type: "tick",
    },
    {
      name: "Automation Adapto System",
      accessor: (rowData: any) => {
        return {
          value: rowData?.AutomationAdaptoSystem
            ? rowData?.AutomationAdaptoSystem
            : "NONE",
        };
      },
    },
    {
      name: "Automation Tote Fill",
      accessor: "AutomationToteFill",
    },
    {
      name: "Automation Min Totes",
      accessor: "AutomationMinTotes",
    },
    {
      name: "High Risk",
      accessor: "HighRisk",
      type: "tick",
    },
    {
      name: "Strap Totes",
      accessor: "StrapTotes",
      type: "tick",
    },
    {
      name: "Expiry Date Required",
      accessor: "ExpiryDateRequired",
      type: "tick",
    },
    {
      name: "Pick Pack Indicator",
      accessor: "PickPack",
      type: "tick",
    }
  ];

  if (user?.isLDMService) {
    columnDefinition.push({
      name: "",
      accessor: "",
      type: "btn",
      btnType: "edit",
    });
  }

  useEffect(() => {
    let payload = {
      service: endpoints.searchProductData(),
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
      isColumnMerge: true,
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default ProductAttributes;
